import React, {Component} from 'react';
import {
    Paper,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from "@material-ui/core";
import DateUtil from "../../../Utils/DateUtil";
import {ArrowDownward, ArrowUpward} from "@material-ui/icons";
import Recibo from "./Recibo";
import PaginationComponent
    from "../../../Components/PaginationComponent/PaginationComponent";
import SpacerComponent
    from "../../../Components/SpacerComponent/SpacerComponent";
import {ExtractContext} from "../../../Contexts/ExtractContext";
import ExtractClientScreen from "../ExtractClientScreen/ExtractClientScreen";
import {BlockClientContext} from "../../../Contexts/BlockClientContext";

class TableExtract extends Component {
    static contextType = BlockClientContext;

    constructor(props) {
        super(props);

        this.enterValue = [
            'Nota fiscal',
            'Recibo',
        ];
    }

    makeRowTable() {

        const rows = [];
        const context = this;

        Object.keys(context.props.extractList).forEach(function (key, index) {
            const value = context.props.extractList[key];
            console.log(value);
            rows.push(
                <TableRow key={value.uuid}>
                    <TableCell>{context.tryGetLink(value)}</TableCell>
                    <TableCell>{value.email}</TableCell>
                    <TableCell>{DateUtil.raw(value.datetime).toDateTime24()}</TableCell>
                </TableRow>
            );
        });

        return rows;

    }

    tryGetLink(value) {
        try {

            return <a
                href={`${ExtractClientScreen.ROUTE}/${value.uuid}/${this.context.parent.state.fidelity.uuid}`}>{value.name}</a>;

        } catch (e) {
            console.log('321312');
            console.log(e);
            return value.name;
        }
    }

    render() {
        return (
            <div>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Último Acesso</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.makeRowTable()}
                        </TableBody>
                    </Table>
                </TableContainer>
                <SpacerComponent height={20}/>
                <PaginationComponent
                    total={parseInt(this.context.parent.state?.pagination?.total)}
                    perPage={parseInt(this.context.parent.state?.pagination?.per_page)}
                    currentPage={parseInt(this.context.parent.state?.pagination?.current_page)}
                    lastPage={parseInt(this.context.parent.state?.pagination?.last_page)}
                    itensVisible={2}
                    onChangePage={(page) => {
                        this.context.parent.doChangePage({page});
                    }}/>
            </div>
        );
    }
}

export default TableExtract;